import React from "react";
import { render, screen } from "@testing-library/react";
import "@testing-library/jest-dom";

import { FullPageChatLayout } from "./FullPageChatLayout";

jest.mock("@metalmind-ab/mmagent-chat-ui", () => ({
  ChatMessage: ({ message }: { message: any }) => (
    <div
      data-testid={`chat-message-${message.id}`}
      data-presented-role={message.role}
    >
      {message.content}
    </div>
  ),
  JobProgressIndicator: () => null,
  useChatStore: (selector: (state: any) => any) =>
    selector({
      backgroundJobs: [],
      removeBackgroundJob: jest.fn(),
      messages: [],
    }),
}));

beforeAll(() => {
  Object.defineProperty(HTMLElement.prototype, "scrollIntoView", {
    configurable: true,
    value: jest.fn(),
  });
  Object.defineProperty(URL, "createObjectURL", {
    configurable: true,
    value: jest.fn(() => "blob:test-url"),
  });
  Object.defineProperty(URL, "revokeObjectURL", {
    configurable: true,
    value: jest.fn(),
  });
});

const currentUser = {
  id: "collab-self",
  name: "Bob Example",
  email: "bob@example.com",
  role: "user",
  status: "accepted",
  role_in_org: "member",
} as any;

const recentMessage = {
  id: "recent-1",
  role: "assistant",
  content: "Recent reply",
  createdAt: new Date("2026-04-25T10:05:00Z"),
} as any;

const renderLayout = (
  overrides: Partial<React.ComponentProps<typeof FullPageChatLayout>> = {},
) =>
  render(
    <FullPageChatLayout
      messages={[recentMessage]}
      onSendMessage={jest.fn()}
      isLoading={false}
      conversations={[]}
      onLoadConversation={jest.fn()}
      onNewConversation={jest.fn()}
      onSearchConversations={jest.fn()}
      onLoadMoreConversations={jest.fn()}
      conversationsLoading={false}
      currentConversationId={1}
      currentUser={currentUser}
      hasOlderMessages
      onLoadOlderMessages={jest.fn()}
      {...overrides}
    />,
  );

describe("FullPageChatLayout older-message pagination composes with sender-trust presentation", () => {
  it("resolves presentation role from sender_user_id for messages that arrived via Load earlier messages, not just the initial page", () => {
    const ownOlderMessage = {
      id: "older-own",
      role: "user",
      content: "My earlier turn",
      createdAt: new Date("2026-04-25T10:00:00Z"),
      metadata: { sender_user_id: "collab-self" },
    } as any;
    const otherOlderMessage = {
      id: "older-other",
      role: "user",
      content: "Someone else's earlier turn",
      createdAt: new Date("2026-04-25T10:01:00Z"),
      metadata: { sender_user_id: "owner-1" },
    } as any;

    // Simulates the state after onLoadOlderMessages resolves and the parent
    // prepends the fetched page ahead of the already-rendered recent message
    // -- the bounded-pagination path this PR keeps from HEAD, feeding the
    // same currentUserId-driven presentation-role resolution this PR kept
    // from dev's merged branch.
    renderLayout({
      messages: [ownOlderMessage, otherOlderMessage, recentMessage],
    });

    expect(
      screen.getByRole("button", { name: /load earlier messages/i }),
    ).toBeInTheDocument();
    expect(screen.getByTestId("chat-message-older-own")).toHaveAttribute(
      "data-presented-role",
      "user",
    );
    expect(screen.getByTestId("chat-message-older-other")).toHaveAttribute(
      "data-presented-role",
      "assistant",
    );
  });
});
